import React, { useEffect, useState } from "react";
import useFetchData from "../Hooks/useFetchData";
import { Link } from "react-router-dom";
import Api from "../Hooks/Api";

import { Bar, Pie, Line } from "react-chartjs-2";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
);

const Dashboard = () => {
  // ========================
  // API CALLS
  // ========================
  const ProductsChart = useFetchData("api/dashboard/products/chart");
  const MouChart = useFetchData("api/dashboard/mou/chart");
  const InvestmentChart = useFetchData("api/dashboard/investment/chart");

  const [notification, setnotification] = useState({});

  // ========================
  // TOTALS
  // ========================
  const fetchSummaries = async () => {
    try {
      const response = await Api.get("api/dashboard/getTotals");
      if (response.status === 200) {
        setnotification(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchSummaries();
  }, []);

  // ========================
  // SAFE DATA EXTRACTION
  // ========================
  const products = ProductsChart.response?.data || [];
  const mous = MouChart.response?.data || [];
  const investments = InvestmentChart.response?.data || [];

  // ========================
  // PRODUCTS CHART
  // ========================
  const productsBarData = {
    labels: products.map((x) => x.categoryName),
    datasets: [
      {
        label: "Products",
        data: products.map((x) => Number(x.total)),
        backgroundColor: "#36a2eb",
      },
    ],
  };

  // ========================
  // MOU CHART
  // ========================
  const mouPieData = {
    labels: mous.map((x) => x.statusName || "Unknown"),
    datasets: [
      {
        data: mous.map((x) => Number(x.total)),
        backgroundColor: ["#ff6384", "#36a2eb", "#ffce56", "#4bc0c0"],
      },
    ],
  };

  // ========================
  // INVESTMENT CHART
  // ========================
  const investmentData = {
    labels: investments.map((x) => x.month),
    datasets: [
      {
        label: "Investments",
        data: investments.map((x) => Number(x.total)),
        borderColor: "#4bc0c0",
        backgroundColor: "#4bc0c0",
      },
    ],
  };

  return (
    <div id="content" className="content">
      <h1 className="page-header mb-3">Dashboard</h1>

      {/* ================= KPI CARDS ================= */}
      <div className="row">
        <div className="col-xl-3 col-md-6">
          <div className="widget widget-stats bg-gray">
            <h4>MARKETING CAMPAIGNS</h4>
            <p>{notification.marketingCampaign || 0}</p>
          </div>
        </div>

        <div className="col-xl-3 col-md-6">
          <div className="widget widget-stats bg-green">
            <h4>MOUs</h4>
            <p>{notification.mou || 0}</p>
          </div>
        </div>

        <div className="col-xl-3 col-md-6">
          <div className="widget widget-stats bg-orange">
            <h4>PRODUCTS</h4>
            <p>{notification.products || 0}</p>
          </div>
        </div>

        <div className="col-xl-3 col-md-6">
          <div className="widget widget-stats bg-red">
            <h4>INCIDENTS</h4>
            <p>{notification.incidents || 0}</p>
          </div>
        </div>
      </div>

      {/* ================= PRODUCTS BAR ================= */}
      <div className="row mt-3">
        <div className="col-xl-12">
          <div className="panel-heading bg-dark text-white p-2">
            Products Per Category
          </div>
          <div className="bg-white p-3" style={{ height: "400px" }}>
            {products.length > 0 && <Bar data={productsBarData} />}
          </div>
        </div>
      </div>

      {/* ================= MOU PIE ================= */}
      <div className="row mt-3">
        <div className="col-xl-12">
          <div className="panel-heading bg-dark text-white p-2">
            MOU Per Status
          </div>
          <div className="bg-white p-3" style={{ height: "400px" }}>
            {mous.length > 0 && <Pie data={mouPieData} />}
          </div>
        </div>
      </div>

      {/* ================= INVESTMENT LINE ================= */}
      <div className="row mt-3">
        <div className="col-xl-12">
          <div className="panel-heading bg-dark text-white p-2">
            Investments Per Month
          </div>
          <div className="bg-white p-3" style={{ height: "400px" }}>
            {investments.length > 0 && <Line data={investmentData} />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
